export default __webpack_public_path__ + "static/media/toggle-notifications-w.f09af5d2.svg";